// extracted by mini-css-extract-plugin
export var alert = "ClampAlert-module--alert--675c2";
export var clamp = "ClampAlert-module--clamp--036b7";
export var content = "ClampAlert-module--content--97f20";
export var hasClamp = "ClampAlert-module--hasClamp--e5b15";
export var text = "ClampAlert-module--text--d155d";